import { toBlob } from 'html-to-image';

export async function htmlLabelToBlobImage(componentRef){
  try {
        await new Promise((res) => setTimeout(res, 100)); // 1 frame, in case we just generated de HTML
        console.log(componentRef);
        let blob = await toBlob(componentRef, {
          pixelRatio: 2,
          cacheBust: true,
          backgroundColor: "#ffffff",
        });
        const rotatedBlob = await rotateBlob(blob, 90);
        return rotatedBlob;
      } catch (err) {
        console.error("Image generation failed", err);
      }
}

export async function rotateBlob(blob, degrees = 90) {
  const imageBitmap = await createImageBitmap(blob);

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (degrees === 90 || degrees === 270) {
    canvas.width = imageBitmap.height;
    canvas.height = imageBitmap.width;
  } else {
    canvas.width = imageBitmap.width;
    canvas.height = imageBitmap.height;
  }

  ctx.translate(canvas.width / 2, canvas.height / 2);
  ctx.rotate((degrees * Math.PI) / 180);
  ctx.drawImage(imageBitmap, -imageBitmap.width / 2, -imageBitmap.height / 2);

  return new Promise((resolve) => {
    canvas.toBlob((rotatedBlob) => resolve(rotatedBlob), "image/png");
  });
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url); // cleanup
}